import type { Message } from "@ai-sales/contracts";

const pad = (value: number) => String(value).padStart(2, "0");

function calendarDayKey(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function startOfLocalDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

export function shouldShowMessageTime(messages: Message[], index: number): boolean {
  if (index === 0) return true;
  const current = new Date(messages[index]!.createdAt);
  const previous = new Date(messages[index - 1]!.createdAt);
  return calendarDayKey(current) !== calendarDayKey(previous) ||
    current.getTime() - previous.getTime() >= 5 * 60_000;
}

export function formatConversationTime(value: string, nowValue = new Date()): string {
  const date = new Date(value);
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  const dayDifference = Math.round((startOfLocalDay(nowValue) - startOfLocalDay(date)) / 86_400_000);
  if (dayDifference === 0) return time;
  if (dayDifference === 1) return `昨天 ${time}`;
  if (date.getFullYear() === nowValue.getFullYear()) {
    return `${date.getMonth() + 1}月${date.getDate()}日 ${time}`;
  }
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${time}`;
}

export function conversationDateGroup(value: string, nowValue = new Date()): "今天" | "昨天" | "最近7天" | "更早" {
  const date = new Date(value);
  const dayDifference = Math.round((startOfLocalDay(nowValue) - startOfLocalDay(date)) / 86_400_000);
  if (dayDifference <= 0) return "今天";
  if (dayDifference === 1) return "昨天";
  if (dayDifference <= 7) return "最近7天";
  return "更早";
}
